// extracted by mini-css-extract-plugin
export default {"text":"text_text__rwvWa","text-s":"text_text-s__7mCGQ","text-m":"text_text-m__g3lb6","text-l":"text_text-l__0ZT24"};